var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"provider"}},[_c('v-row',[_c('h1',{staticClass:"mt-12 mb-12  font-weight-light"},[_vm._v(" Contact Us ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }